//is loggedin
export const isLoggedIn = () => {
  let data = localStorage.getItem("data");
  if (data == null) {
    return false;
  } else {
    return true;
  }
};
//doLogin=>data=>set to localStorage
export const doLogin = (data, next) => {
  localStorage.setItem("data", JSON.stringify(data));

  next();
};
//do logout=>remove from localstorage
export const doLogout = (next) => {
  localStorage.removeItem("data");
  localStorage.removeItem("user_toggled_theme");
  localStorage.removeItem("theme");
  localStorage.removeItem("app_theme_mode");
  if (next) next();
};

//get currentuser
export const getCurrentUserDetail = () => {
  if (isLoggedIn()) {
    return JSON.parse(localStorage.getItem("data"));
  } else {
    return undefined;
  }
};
